/**
 * Logical asset keys → public paths.
 * Player: replace `run.png` / `jump.png` for a full character swap.
 * `ASSET_VER` busts browser cache after regenerating art.
 */
export const ASSET_VER = "20260731v3";

const v = (p: string) => `${p}?v=${ASSET_VER}`;

export const AssetManifest = {
  // Full connected character poses (feet at bottom of sprite)
  "player.run": v("/assets/player/run.png"),
  "player.jump": v("/assets/player/jump.png"),

  // World
  "tiles.ground": v("/assets/tiles/ground.png"),
  "tiles.platform": v("/assets/tiles/platform.png"),
  "bg.skyline": v("/assets/bg/skyline.png"),
  "bg.cloud": v("/assets/bg/cloud.png"),

  // Obstacles / enemies
  "obs.grease_drum": v("/assets/obstacles/grease_drum.png"),
  "obs.oil_slick": v("/assets/obstacles/oil_slick.png"),
  "obs.mayo_puddle": v("/assets/obstacles/mayo_puddle.png"),
  "obs.kebab_spikes": v("/assets/obstacles/kebab_spikes.png"),
  "obs.deep_fryer": v("/assets/obstacles/deep_fryer.png"),
  "obs.brick_block": v("/assets/obstacles/brick_block.png"),
  "obs.horizontal_dick": v("/assets/obstacles/horizontal_dick.png"),
  "obs.shit_pile": v("/assets/obstacles/shit_pile.png"),
  "obs.pipe": v("/assets/obstacles/pipe.png"),
  "enemy.health_inspector": v("/assets/enemies/health_inspector.png"),
  "enemy.scooter": v("/assets/enemies/scooter.png"),
  "enemy.soda_can": v("/assets/enemies/soda_can.png"),
  "enemy.policeman": v("/assets/enemies/policeman.png"),
  "enemy.giant_dick": v("/assets/enemies/giant_dick.png"),
  "enemy.pastor": v("/assets/enemies/pastor.png"),

  // Collectibles
  "item.drumstick": v("/assets/collectibles/drumstick.png"),
  "item.coin": v("/assets/collectibles/coin.png"),
  "item.bucket_power": v("/assets/collectibles/bucket_power.png"),
  "item.joint": v("/assets/collectibles/joint.png"),
  "item.forty_oz": v("/assets/collectibles/forty_oz.png"),
  "item.hennessy": v("/assets/collectibles/hennessy.png"),
  "item.crack": v("/assets/collectibles/crack.png"),

  // UI
  "ui.panel": v("/assets/ui/panel.png"),
} as const;

export type AssetKey = keyof typeof AssetManifest;
